import { Entity } from '../../../../../types/entity';
import { calcRelativeTime, formatDateTime } from '../../../../../utilities/formatting';
import XeroLogo from '../../../../../assets/xero.png';
import IntegrationOverview from '../../../../../components/integration-overview/IntegrationOverview';
import XeroEntityConfigure from './XeroEntityConfigure';
import XeroEntityDisconnect from './XeroEntityDisconnect';
import XeroEntityRefresh from '../../../integrations/xero/XeroEntityRefresh';

type EntityXeroIntegrationProps = {
    entity: Entity;
    onXeroError: (error?: { name: string; message: string }) => void;
};

function EntityXeroIntegration({ entity, onXeroError }: EntityXeroIntegrationProps): JSX.Element {
    const { xero } = entity.integrations;

    const content = !xero
        ? []
        : [
              { label: 'Created By', value: `${xero.createdBy?.firstName} ${xero.createdBy?.lastName}` },
              { label: 'Authorised By', value: `${xero.authorisedBy?.firstName} ${xero.authorisedBy?.lastName}` },
              { label: 'Created', value: calcRelativeTime(xero.createdAt), tooltip: formatDateTime(xero.createdAt) },
              { label: 'Last Refreshed', value: calcRelativeTime(xero.refreshedAt), tooltip: formatDateTime(xero.refreshedAt) },
          ];

    return (
        <IntegrationOverview
            title="Xero"
            description="Pull your trial balance and entity information from Xero."
            active={Boolean(xero)}
            logo={XeroLogo}
            sideContent={content}
            supportLink="https://support.cimplico.com/support/solutions/articles/51000328994-integration-with-xero"
        >
            <div className={`mt-4`}>{xero ? <XeroEntityDisconnect entity={entity} /> : <XeroEntityConfigure entity={entity} />}</div>
            {xero && <XeroEntityRefresh entityId={entity.id} onXeroError={onXeroError} />}
        </IntegrationOverview>
    );
}
export default EntityXeroIntegration;
